/** Период сравнения против данных витрины: он должен лежать внутри диапазона данных каждого
 *  выбранного юрлица, иначе Δ строится по неполным данным и вводит в заблуждение. */
import type { OzMeta } from "@/api/ozonAnalytics";
import { fmtDate } from "./format";
import type { Range } from "./period";

/** Список проблем (пустой — сравнение внутри данных). `legal` — выбранное юрлицо или null («оба»:
 *  проверяем каждое из `legalNames`). Нет диапазона у юрлица — данных по нему нет вовсе. */
export function cmpOutOfData(
  cmp: Range | null,
  ranges: OzMeta["legal_ranges"],
  legalNames: string[],
  legal: string | null,
): string[] {
  if (!cmp) return [];
  const names = legal ? [legal] : legalNames;
  const out: string[] = [];
  for (const name of names) {
    const r = ranges.find((x) => x.legal_name === name);
    if (!r) {
      out.push(`${name}: данных в витрине нет`);
    } else if (cmp.to < r.date_from) {
      out.push(`${name}: целиком раньше начала данных (с ${fmtDate(r.date_from)})`);
    } else if (cmp.from > r.date_to) {
      out.push(`${name}: целиком позже конца данных (по ${fmtDate(r.date_to)})`);
    } else if (cmp.from < r.date_from) {
      out.push(`${name}: частично раньше начала данных (с ${fmtDate(r.date_from)})`);
    } else if (cmp.to > r.date_to) {
      out.push(`${name}: частично позже конца данных (по ${fmtDate(r.date_to)})`);
    }
  }
  return out;
}

/** Текст плашки/подсказки или null. */
export function cmpWarningText(issues: string[]): string | null {
  return issues.length ? `сравнение за пределами данных: ${issues.join("; ")}` : null;
}
